import { addWeeks, getISOWeek, getISOWeeksInYear, startOfISOWeekYear } from "date-fns";

/**
 * Returns the Monday at 00:00 (local time) that starts an ISO-8601 week.
 *
 * - `year` is an ISO week-numbering year: week 1 is the week containing January 4th, so it may
 *   start in late December of the previous calendar year (week 1 of 2026 starts 2025-12-29).
 * - `week` counts from that week 1 and is allowed to overflow or underflow: week 53 of a 52-week
 *   year rolls over to week 1 of the next year, week 0 is the last week of the previous year.
 *   Callers rely on this to navigate with `week + n`.
 * - A missing `year` (falsy or NaN) falls back to today's ISO year.
 * - A missing `week` (null, undefined or NaN, as produced by `parseInt(undefined)` before the
 *   planning week is known) falls back to today's week number, capped to the target year's
 *   week count so that week 53 never spills into the next year.
 */
const getWeekStart = (week, year) => {
    const today = new Date();
    const yearStart = startOfISOWeekYear(year ? new Date(year, 0, 4) : today);
    const hasWeek = week !== null && week !== undefined && !Number.isNaN(week);
    const isoWeek = hasWeek ? week : Math.min(getISOWeek(today), getISOWeeksInYear(yearStart));
    return addWeeks(yearStart, isoWeek - 1);
};

export default getWeekStart;
